// Mirror of backend site_defaults.py - used as fallback when the API hasn't responded yet.
// IMPORTANT: keep field names in sync with /app/backend/site_defaults.py
const IMG_BASE = "/images";

export const defaultContent = {
  hero: {
    pillText: "100% E-learning \u00b7 Sin horarios fijos",
    titleLine1: "Tu pasaporte",
    titleLine2Prefix: "al ",
    titleLine2Highlight: "\u00e9xito",
    titleLine3Highlight: "acad\u00e9mico",
    titleLine4: "y profesional.",
    subtitle:
      "Abre las puertas a mejores empleos, estudios internacionales y viajes sin fronteras. Aprende ingl\u00e9s de forma activa, pr\u00e1ctica y a tu propio ritmo, con tutor\u00eda personalizada incluida.",
    ctaText: "Conoce el m\u00e9todo",
    ctaHref: "#metodo",
    videoUrl: "/assets/hero-video.mp4",
    videoThumbnail: `${IMG_BASE}/elementary.jpg`,
    chip1Title: "Certificado oficial",
    chip1Subtitle: "Al finalizar cada nivel",
    chip2Title: "Tu propio ritmo",
    chip2Subtitle: "Sin horarios fijos",
    stat1Value: "24/7",
    stat1Label: "Acceso a plataforma",
    stat2Value: "12+",
    stat2Label: "A\u00f1os en adelante",
    stat3Value: "1:1",
    stat3Label: "Tutor\u00eda dedicada",
  },
  ticker: [
    "Plataforma interactiva 24/7",
    "Tutor\u00eda 1:1 con feedback",
    "Certificaci\u00f3n al completar nivel",
    "Sin horarios fijos",
    "Plan Regular o Intensivo",
    "Ingl\u00e9s para el mundo real",
    "Beneficios por referidos",
    "Acceso 7 d\u00edas a la semana",
  ],
  levels: {
    kicker: "Niveles de estudio",
    titleLine1: "De cero a fluidez, en",
    titleLine2Highlight: "cuatro etapas",
    titleLine2Suffix: " claras.",
    subtitle: "Avanza paso a paso por un programa estructurado que reconoce tu progreso al final de cada nivel.",
    items: [
      { n: "01", code: "A1", title: "Beginner", image: `${IMG_BASE}/beginner.jpg`, desc: "Tu primer contacto con el idioma. Aprender\u00e1s expresiones cotidianas b\u00e1sicas, saludos y c\u00f3mo presentarte, sentando las bases para comunicarte desde cero." },
      { n: "02", code: "A2", title: "Elementary", image: `${IMG_BASE}/elementary.jpg`, desc: "Ideal para desenvolverte en situaciones simples. Intercambia informaci\u00f3n sobre temas familiares: tu familia, compras y entorno cercano." },
      { n: "03", code: "B1 \u00b7 B2", title: "Intermediate", image: `${IMG_BASE}/intermediate.jpg`, desc: "El puente hacia la fluidez. Mant\u00e9n conversaciones fluidas, expresa opiniones y comprende textos complejos sobre temas concretos y abstractos." },
      { n: "04", code: "C1 \u00b7 C2", title: "Advanced", image: `${IMG_BASE}/advanced.jpg`, desc: "Dominio profesional y social. Expr\u00e9sate con espontaneidad y detalle, usando el idioma con flexibilidad para fines acad\u00e9micos y laborales exigentes." },
    ],
  },
  method: {
    kicker: "Metodolog\u00eda",
    titleLine1: "Cuatro pilares para",
    titleLine2Prefix: "que ",
    titleLine2Highlight: "aprendas en serio",
    titleLine2Suffix: ".",
    subtitle: "Una experiencia de aprendizaje 100% online, dise\u00f1ada para adaptarse a tu vida \u2014 no al rev\u00e9s.",
    items: [
      { n: "01", title: "Libertad total de horarios", desc: "Metodolog\u00eda 100% E-learning: accede a la plataforma cuando prefieras, avanza a tu propio ritmo y completa tus asignaciones seg\u00fan tu disponibilidad. Sin clases virtuales con hora fija.", image: `${IMG_BASE}/student-tablet.jpg` },
      { n: "02", title: "Plataforma intuitiva 24/7", desc: "Cada lecci\u00f3n incluye videos explicativos detallados y material de pr\u00e1ctica instant\u00e1nea. Avanza con herramientas interactivas de self-study disponibles cuando lo necesites.", image: `${IMG_BASE}/intuitive-platform.jpg` },
      { n: "03", title: "Evaluaci\u00f3n y refuerzo interactivo", desc: "Consolida lo aprendido con actividades din\u00e1micas. El sistema te ofrece refuerzo constante para que domines cada tema antes de pasar al siguiente nivel.", image: `${IMG_BASE}/interactive-eval.jpg` },
      { n: "04", title: "Tutor\u00eda personalizada con feedback", desc: "No estar\u00e1s solo. Un tutor personal revisa cada actividad y te env\u00eda retroalimentaci\u00f3n espec\u00edfica para corregir errores y potenciar tu comunicaci\u00f3n.", image: `${IMG_BASE}/tutoria.jpg` },
    ],
  },
  platform: {
    kicker: "La plataforma",
    titleLine1: "Un entorno dise\u00f1ado",
    titleLine2Prefix: "para tu ",
    titleLine2Highlight: "comodidad",
    titleLine2Suffix: ".",
    subtitle: "Cada lecci\u00f3n incluye videos explicativos detallados, material de pr\u00e1ctica instant\u00e1nea y actividades de evaluaci\u00f3n din\u00e1micas. Avanza a tu ritmo con herramientas interactivas de self-study disponibles 24/7.",
    bullets: [
      "Videos explicativos en cada lecci\u00f3n",
      "Pr\u00e1ctica instant\u00e1nea y feedback autom\u00e1tico",
      "Tutor personal que revisa tus actividades",
      "Sistema de refuerzo nivel a nivel",
    ],
  },
  age: {
    kicker: "Para j\u00f3venes y adultos",
    titleLine1: "Dise\u00f1ado a partir",
    titleLine2Prefix: "de los ",
    titleLine2Highlight: "12 a\u00f1os",
    titleLine2Suffix: ".",
    subtitle: "A esta edad los estudiantes desarrollan mayor capacidad de pensamiento l\u00f3gico y anal\u00edtico. A diferencia del aprendizaje infantil por repetici\u00f3n, los alumnos 12+ pueden comprender estructuras, identificar patrones y aplicar el idioma de forma pr\u00e1ctica.",
    bullets: [
      "Comprenden estructuras gramaticales con profundidad.",
      "Identifican patrones y los aplican en nuevos contextos.",
      "Aprendizaje visual y pr\u00e1ctico con ejercicios de aplicaci\u00f3n inmediata.",
    ],
    chipText: "Programa dise\u00f1ado para j\u00f3venes desde 12 a\u00f1os y adultos que buscan un aprendizaje estructurado.",
  },
  testimonial: {
    kicker: "Validez internacional",
    quote: "Ingl\u00e9s para el mundo real, \u00e9xito con validez internacional.",
    subtitle: "Domina el ingl\u00e9s del mundo real. Nuestro contenido est\u00e1 dise\u00f1ado para que te comuniques con fluidez en cualquier situaci\u00f3n y obtengas la confianza necesaria para alcanzar tu certificaci\u00f3n internacional.",
    chipTitle: "Tu esfuerzo, recompensado",
    chipSubtitle: "Certificado en PDF al aprobar cada nivel.",
  },
  plans: {
    kicker: "Modalidades de aprendizaje",
    titleLine1: "Elige el ritmo que",
    titleLine2Prefix: "se adapta a ",
    titleLine2Highlight: "tu vida",
    titleLine2Suffix: ".",
    subtitle: "Inscripci\u00f3n \u00fanica de $20 y dos planes mensuales pensados para distintos objetivos.",
    inscriptionFee: "$20",
    regular: {
      badge: "Equilibrio y consistencia",
      name: "Plan Regular",
      description: "Ideal para quienes buscan progreso constante sin presiones.",
      price: "$40",
      priceSuffix: "/mes",
      features: [
        { label: "Duraci\u00f3n total", value: "6 meses" },
        { label: "Carga acad\u00e9mica", value: "4 actividades por semana" },
        { label: "Disponibilidad", value: "7 d\u00edas a la semana" },
        { label: "Horarios", value: "Sin horarios fijos \u00b7 t\u00fa decides" },
      ],
      ctaText: "Inscr\u00edbete en Regular",
    },
    intensive: {
      badge: "Resultados en tiempo r\u00e9cord",
      name: "Plan Intensivo",
      description: "Para quienes tienen una meta a corto plazo y pueden dedicar m\u00e1s tiempo semanal.",
      price: "$80",
      priceSuffix: "/mes",
      features: [
        { label: "Duraci\u00f3n total", value: "3 meses" },
        { label: "Carga acad\u00e9mica", value: "8 actividades por semana" },
        { label: "Disponibilidad", value: "7 d\u00edas \u00b7 acceso 24/7" },
        { label: "Horarios", value: "Sin horarios fijos \u00b7 ritmo intenso" },
      ],
      ctaText: "Inscr\u00edbete en Intensivo",
      badgeRibbon: "M\u00e1s r\u00e1pido",
    },
  },
  benefits: {
    kicker: "\u00a1Aprovecha los beneficios!",
    titleLine1: "Aprende acompa\u00f1ado",
    titleLine2Prefix: "y ",
    titleLine2Highlight: "ahorra m\u00e1s",
    titleLine2Suffix: ".",
    referral: {
      kicker: "Beneficio por referidos",
      title: "Trae a un amigo y elimina tu inscripci\u00f3n.",
      desc: "Si te inscribes junto a otra persona, quedas exento del pago de inscripci\u00f3n. Solo cubres tu mensualidad.",
      image: `${IMG_BASE}/referral.jpg`,
    },
    group: {
      kicker: "Inscripci\u00f3n en grupo",
      title: "3 o m\u00e1s personas: nadie paga inscripci\u00f3n.",
      desc: "Si se registran 3 o m\u00e1s personas al mismo tiempo, ninguno de los integrantes paga el costo de inscripci\u00f3n.",
      ctaText: "Empieza ahora",
    },
  },
  finalCta: {
    kicker: "\u00bfListo para empezar?",
    titleLine1: "Aprende ingl\u00e9s a",
    titleLine2: "tu propio ritmo,",
    titleLine3: "con apoyo experto.",
    subtitle: "Sin horarios fijos. Tutor\u00eda personalizada incluida. Certificado al finalizar cada nivel. Empieza hoy mismo.",
    primaryCtaText: "Ir al formulario de registro",
    secondaryCtaText: "Habla por WhatsApp",
    image: `${IMG_BASE}/registration.jpg`,
  },
  contact: {
    kicker: "Si deseas contactarnos",
    titleLine1: "Obt\u00e9n todos",
    titleLine2: "los detalles y",
    titleLine3: "asegura tu cupo.",
    subtitle: "Estamos listos para asesorarte a trav\u00e9s de cualquiera de nuestros canales oficiales. Te respondemos personalmente.",
    successTitle: "\u00a1Gracias! Hemos recibido tu mensaje.",
    successSubtitle: "Te responderemos muy pronto al correo que nos indicaste.",
  },
  footer: {
    tagline: "Cursos de ingl\u00e9s 100% online con tutor\u00eda personalizada, plataforma 24/7 y certificaci\u00f3n al completar cada nivel.",
    rightsText: "Hecho con cuidado para personas que aprenden con prop\u00f3sito.",
  },
};
